import * as Sentry from '@sentry/react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack } },
    });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="flex min-h-screen items-center justify-center bg-bg px-4">
        <div className="epi-card tone-blue max-w-md text-center">
          <p className="label dash mb-3 text-left">RUNTIME ERROR</p>
          <h1 className="display mb-4 text-[36px]">
            Une erreur inattendue est survenue
          </h1>
          <p className="mb-6 text-muted">
            Veuillez rafraîchir la page. Si le problème persiste, contactez
            l&apos;administrateur.
          </p>
          <button onClick={() => window.location.reload()} className="btn-blue">
            Rafraîchir la page
          </button>
        </div>
      </div>
    );
  }
}
